import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AudioRecorder from '../../AudioRecorder/AudioRecorder';
import ObjectActionCreators from '../../../actions';
import {
  TextAreaContainer,
  TextAreaHeader,
  TextAreaTitle,
  TextArea,
  ControlsContainer,
  SubmitButton,
  FeedbackMessage,
} from './PersistentTextAreaCSS';

const PersistentTextArea = () => {
  const dispatch = useDispatch();
  const currentInteraction = useSelector(
    (state) => state.interaction.currentInteraction
  );
  // Use the alternativeResponse from the state
  const alternativeResponse = useSelector(
    (state) => state.interaction.alternativeResponse
  );
  const [feedbackVisible, setFeedbackVisible] = useState(false);

  const questionId = currentInteraction?.data?.questionId || null;

  // Handle input changes in the persistent text area
  const handleInputChange = (event) => {
    dispatch({
      type: 'VOICE_TO_TEXT_INPUT_CLIENT_CHANGED',
      transcription: event.target.value,
      targetField: 'alternative', // Specify this is for the alternative field
    });
  };

  // Handle submission of the alternative response
  const handleSubmit = () => {
    if (!alternativeResponse.trim()) {
      alert('Please enter a response before submitting.');
      return;
    }

    if (currentInteraction && currentInteraction.data) {
      dispatch({
        type: 'INTERACTION_RESPONSE',
        payload: {
          questionId: currentInteraction.data.questionId,
          response: alternativeResponse,
          isAlternative: true, // Mark this as an alternative response
        },
      });

      // Show feedback message
      setFeedbackVisible(true);

      // Hide feedback after 3 seconds
      setTimeout(() => {
        setFeedbackVisible(false);
      }, 3000);
    }
  };

  const showFeedback = () => {
    setFeedbackVisible(true);
    setTimeout(() => setFeedbackVisible(false), 3000);
  };

  // Handle audio recording for the alternative response
  const handleAudioRecording = (blob) => {
    dispatch(ObjectActionCreators.voiceToTextInput(blob, 'alternative')); // Pass target field
  };

  // Don't render if there's no current interaction
  if (!currentInteraction || !currentInteraction.data) return null;

  return (
    <TextAreaContainer>
      <TextArea
        value={alternativeResponse}
        onChange={handleInputChange}
        placeholder="Type your response here or use the microphone..."
      />

      <ControlsContainer>
        <AudioRecorder onEndRecording={handleAudioRecording} />
        <SubmitButton
          onClick={handleSubmit}
          disabled={!alternativeResponse.trim()}
        >
          Submit Custom Response
        </SubmitButton>
      </ControlsContainer>

      <FeedbackMessage visible={feedbackVisible}>
        response submitted successfully please wait
      </FeedbackMessage>
    </TextAreaContainer>
  );
};

export default PersistentTextArea;
